/**
 * SDK Version Information
 */
export const VERSION = {
  sdk: '1.0.0',
  minServerVersion: '1.0.0',
  maxServerVersion: '1.99.99',
  protocolVersion: '1'
};
